<template>
  <app-layout>
    <v-card class="ma-3 pa-3">
      <!-- Resume -->
      <v-card-title class="pt-0">
        <v-layout row wrap>
          <v-flex xs6>
            <v-layout align-center justify-start row fill-height>
              <div>
                <h2>Contactos</h2>
              </div>
            </v-layout>
          </v-flex>
          <v-flex xs6>
            <!-- Action buttons -->
            <v-layout align-center justify-end row fill-height>
              <div v-if="selectedTableItems.length >= 1">
                <v-btn color="error" @click="showBulkDeleteContactModal = true">
                  <v-icon left>mdi-delete</v-icon>
                  {{ $t('Eliminar') }}
                </v-btn>
              </div>
              <div>
                <v-btn color="primary" @click="openNewContactForm()">
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t('CREAR CONTACTO') }}
                </v-btn>
              </div>
            </v-layout>
            <!-- End action buttons -->
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <open-billing-contact-table
          ref="contactTable"
          @on-selected-items="onSelectedItems($event)"
          @on-edit-contact="onEditContact($event)"
          @on-delete-contact="onDeleteContact($event)"
        ></open-billing-contact-table>
      </v-card-text>
    </v-card>
    <open-billing-contact-form
      :show-modal="showContactModalForm"
      :key="contactFormKey"
      :contact-id="selectedContactId"
      @click-on-close="closeContactModalForm()"
      @on-saved-contact="onSavedContact($event)"
    ></open-billing-contact-form>
    <!-- Modal to delete single contacts -->
    <v-layout row justify-center>
      <v-dialog v-model="showDeleteContactModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de eliminar el contacto seleccionado?
                  </h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeDeleteContactModal()">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmDeleteContact()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
    <!-- Modal to delete bulk contacts -->
    <v-layout row justify-center>
      <v-dialog v-model="showBulkDeleteContactModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de eliminar los contactos seleccionados?
                  </h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showBulkDeleteContactModal = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmDeleteBulkContacts()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout';
import OpenBillingContactTable from '@/modules/openbilling/components/OpenBillingContactTable';
import OpenBillingContactForm from '@/modules/openbilling/components/OpenBillingContactForm';
import apiCtrl from '@/services/api/abstract/abstract-api';

export default {
  name: 'OpenBillingContacts',
  components: {
    AppLayout,
    'open-billing-contact-table': OpenBillingContactTable,
    'open-billing-contact-form': OpenBillingContactForm,
  },
  props: [],
  data() {
    return {
      showContactModalForm: false,
      showDeleteContactModal: false,
      showBulkDeleteContactModal: false,
      contactFormKey: 0,
      selectedContactId: null,
      selectedTableItems: [],
    };
  },
  mounted() {},
  computed: {
    clavedat() {
      return this.$store.state.clavedat;
    },
  },
  methods: {
    openNewContactForm() {
      this.showContactModalForm = true;
    },
    closeContactModalForm() {
      this.showContactModalForm = false;
      this.resetContactForm();
    },
    resetContactForm() {
      this.contactFormKey++;
      this.selectedContactId = null;
    },
    onSavedContact() {
      this.closeContactModalForm();
      this.getContacts();
    },
    onEditContact(contact) {
      this.selectedContactId = contact.id;
      this.showContactModalForm = true;
    },
    onDeleteContact(contact) {
      this.selectedContactId = contact.id;
      this.showDeleteContactModal = true;
    },
    onSelectedItems(selectedItems) {
      this.selectedTableItems = selectedItems;
    },
    confirmDeleteContact() {
      this.deleteSingleContact(this.selectedContactId);
    },
    confirmDeleteBulkContacts() {
      let ids = [];
      this.selectedTableItems.forEach(item => {
        ids = ids.concat(item['id']);
      });
      this.deleteBulkContacts(ids);
    },
    closeDeleteContactModal() {
      this.showDeleteContactModal = false;
      this.selectedContactId = null;
    },
    deleteSingleContact(id) {
      apiCtrl
        .post(`/openbilling/${this.clavedat}/contacts/delete`, { id: id })
        .then(() => {
          this.closeDeleteContactModal();
          this.getContacts();
        })
        .catch(err => {
          console.log(err);
          this.closeDeleteContactModal();
        });
    },
    deleteBulkContacts(ids) {
      apiCtrl
        .post(`/openbilling/${this.clavedat}/contacts/bulk-delete`, { ids: ids })
        .then(() => {
          this.showBulkDeleteContactModal = false;
          this.getContacts();
        })
        .catch(err => {
          console.log(err);
          this.showBulkDeleteContactModal = false;
        });
    },
    getContacts() {
      this.$refs.contactTable.getBillingContacts();
    },
  },
  watch: {},
};
</script>

<style scoped></style>
